<div class="bmc-working-time-schema">
  <div class="bmc-working-time-schema__top bz-space--stack-l">
    <div class="bz-space--stack-xl">
      <div class="bmc-working-time-schema__top-header">
        <h5 class="bmc-working-time-schema__title">{{'WORKING_TIME_SCHEMA.DESCRIPTION_TITLE' | translate}}</h5>
      </div>
    </div>
    <div class="bmc-working-time-schema__body">
      <working-time-schema-viewer class="bmc-working-time-schema__body--left bz-space--inline-m" [datesCustomUserCalendarViewInput]="datesCustomUserCalendarView" [currentCalendarSelected]="currentCalendarSelected" [selectedUser]="selectedUser"></working-time-schema-viewer>
      <working-time-schema-filters class="bmc-working-time-schema__body--right" [idBaseCalendarSelected]="idCurrentCalendarSelected" (emitUserSelected)="getInfoUserSelected($event)" (emitSelectedCalendar)="selectedCalendar($event)"></working-time-schema-filters>
    </div>
  </div>
  <div class="bmc-working-time-schema__bottom" *ngIf="currentCalendarSelected">
    <bzg-tab-set class="bmc-working-time-schema__tabs" (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'WORKING_TIME_SCHEMA.ADDITIONAL_NON_WORKING_DAYS' | translate | uppercase}}">
        <working-time-schema-table [isWorking]="false" [datesCustomUserTableInput]="datesCustomUserTable" (emitNewDateCustomUser)="newDateCustomUser($event)" (emitEditDateCustomUser)="editDateCustomUser($event)" (emitDeleteDateCustomUser)="deleteDateCustomUser($event)"></working-time-schema-table>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'WORKING_TIME_SCHEMA.CUSTOM_WORKING_HOURS' | translate | uppercase}}">
        <working-time-schema-table [isWorking]="true" [datesCustomUserTableInput]="datesCustomUserTable" (emitNewDateCustomUser)="newDateCustomUser($event)" (emitEditDateCustomUser)="editDateCustomUser($event)" (emitDeleteDateCustomUser)="deleteDateCustomUser($event)"></working-time-schema-table>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
</div>

<div class="bmc-working-time-schema__buttons">
  <bzg-button-secondary class="bz-space--inline-m" [disabled]="!selectedUser" (click)="cancel()">
    {{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
  <bzg-button-primary (click)="save()" [disabled]="!selectedUser">
    {{'GLOBAL.SAVE' | translate}}
  </bzg-button-primary>
</div>